// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 169 ? "3fb82539" : chunkId) + "." + {"67":"2344ad0195e26286","139":"e0b8da9815ba2cf2","169":"3af460c06f7aa33f","895":"a14f7e20a899cfc4"}[chunkId] + ".js";
};